import { ChainId, igraTestnet, kasplexTestnet, kasplexMainnet } from '@pancakeswap/sdk'
import memoize from 'lodash/memoize'
import invert from 'lodash/invert'

export const CHAIN_QUERY_NAME = {
  [ChainId.BSC]: 'bsc',
  [ChainId.BSC_TESTNET]: 'bscTestnet',
  [ChainId.KASPLEX_TESTNET]: 'kasplexTestnet',
  [ChainId.KASPLEX_MAINNET]: 'kasplexMainnet',
  [ChainId.IGRA]: 'igra',
} as const // satisfies Record<ChainId, string>

const CHAIN_QUERY_NAME_TO_ID = invert(CHAIN_QUERY_NAME)

export const getChainId = memoize((chainName: string) => {
  if (!chainName) return undefined
  return CHAIN_QUERY_NAME_TO_ID[chainName] ? +CHAIN_QUERY_NAME_TO_ID[chainName] : undefined
})

export const CHAINS = [kasplexMainnet, kasplexTestnet, igraTestnet]
